import { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  Box,
  Avatar,
  ListItemAvatar,
  Stack,
  Container,
  Tooltip,
  ListItemIcon,
  Divider,
  MenuItem,
  Menu,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";

import { Link } from "react-router-dom";
import headerOptions from "../utils/headerOptions";
import { useAuth } from "../hooks/useAuth";

import Logo from "../images/invirte-logo.png";

import profile from "../images/perfil.svg";
import InvirteText from "../images/invirteText.png";
import InvirteImage from "../images/invirteImage.png";

function GlobalHeader({ LogoProfile, previewImage }) {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { loggedAuth } = useAuth();
  const [options, setOptions] = useState(
    loggedAuth ? headerOptions.logged : headerOptions.default
  );
  const slicedOptions = options.slice(0, options.length - 1);
  useEffect(() => {
    setOptions(!!loggedAuth ? headerOptions.logged : headerOptions.default);
  }, [loggedAuth]);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsDrawerOpen(open);
  };
  return (
    <>
      <AppBar id="GlobalHeader" position="static">
        <Container
          sx={{
            py: 1,
          }}
        >
          <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" spacing={2}>
              {!!loggedAuth && (
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  sx={{
                    color: "#fff",
                    display: {
                      xs: "inherit",
                      lg: "none",
                    },
                  }}
                  onClick={toggleDrawer(true)}
                >
                  <MenuIcon />
                </IconButton>
              )}
              <Box
                component={Link}
                to="/"
                sx={{ display: "flex", alignItems: "center" }}
              >
                <img
                  src={InvirteImage}
                  width={35}
                  style={{ marginRight: "5px" }}
                />
                <img src={InvirteText} width={150} />
              </Box>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              width="fit-content"
              marginLeft="auto"
              marginRight={4}
              sx={{ display: { xs: "none", lg: "inherit" } }}
            >
              {slicedOptions.map((item, i) => (
                <Link key={i} to={item.route}>
                  <ListItem>
                    <Box
                      spacing={1}
                      sx={{
                        display: {
                          xs: "none",
                          md: "none",
                          lg: "inherit",
                          xl: "inherit",
                        },
                        alignItems: "center",
                        borderColor:
                          window.location.pathname === item.route
                            ? "#fff"
                            : "secondary.main",
                        width: "100%",
                        svg: {
                          color: "#fff!important",
                        },
                      }}
                    >
                      <Typography
                        color="white"
                        fontSize="large"
                        fontWeight="normal"
                      >
                        {item.title}
                      </Typography>
                    </Box>
                  </ListItem>
                </Link>
              ))}
            </Stack>

            {!!loggedAuth && (
              <Stack
                direction="row"
                sx={{
                  display: "inherit",
                }}
                spacing={3}
              >
                <Tooltip>
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar src={previewImage || LogoProfile || profile} />
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{ overflow: "hidden", mt: "45px", position: "absolute" }}
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  <MenuItem onClick={handleCloseUserMenu} sx={{ p: 0 }}>
                    <Box
                      component={Link}
                      to="/profile"
                      display="flex"
                      sx={{ width: "100%", py: 1, px: 2 }}
                    >
                      <Typography textAlign="center">Mi Perfil</Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem onClick={handleCloseUserMenu} sx={{ p: 0 }}>
                    <Box
                      component={Link}
                      to="/create/project"
                      display="flex"
                      sx={{ width: "100%", py: 1, px: 2 }}
                    >
                      <Typography textAlign="center">Crear proyecto</Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem onClick={handleCloseUserMenu} sx={{ p: 0 }}>
                    <Box
                      component={Link}
                      to="/me/projects"
                      display="flex"
                      sx={{ width: "100%", py: 1, px: 2 }}
                    >
                      <Typography textAlign="center">Mis proyectos</Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem onClick={handleCloseUserMenu} sx={{ p: 0 }}>
                    <Box
                      component={Link}
                      to="/me/investments"
                      display="flex"
                      sx={{ width: "100%", py: 1, px: 2 }}
                    >
                      <Typography textAlign="center">
                        Mis inversiones
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem onClick={handleCloseUserMenu} sx={{ p: 0 }}>
                    {options.map((row, key) => {
                      if (row.route !== "/logout") return undefined;

                      return (
                        <Box
                          key={key}
                          component={Link}
                          to={row.route}
                          display="flex"
                          gap="3px"
                          sx={{
                            py: 1,
                            px: 2,
                            cursor:
                              window.location.pathname === row.route
                                ? "default"
                                : "pointer",
                          }}
                        >
                          <row.icon />
                          <Typography>{row.title}</Typography>
                        </Box>
                      );
                    })}
                  </MenuItem>
                </Menu>
              </Stack>
            )}
          </Stack>
        </Container>
      </AppBar>
      <Drawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        <div
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <Box bgcolor="black" px={2} height="100vh" overflow="hidden">
            <List sx={{ height: "100%", p: 0, pt: 2 }}>
              <Stack justifyContent="space-between" sx={{ height: "100%" }}>
                <Box>
                  <ListItem sx={{ my: 1 }}>
                    <ListItemAvatar>
                      <Avatar
                        src={Logo}
                        sx={{
                          width: "180px",
                          height: "auto",
                          borderRadius: 0,
                        }}
                      />
                    </ListItemAvatar>
                  </ListItem>
                  {options
                    .filter((item) => item.route !== "/logout")
                    .map((item, i) => (
                      <Link key={i} to={item.route}>
                        <ListItem>
                          <Stack
                            spacing={1}
                            direction="row"
                            sx={{
                              borderBottom: "3px solid",
                              borderColor:
                                window.location.pathname === item.route
                                  ? "#fff"
                                  : "secondary.main",
                              width: "100%",
                              py: 1,
                              svg: {
                                color: "#fff!important",
                              },
                            }}
                          >
                            <item.icon />
                            <Typography color="white">{item.title}</Typography>
                          </Stack>
                        </ListItem>
                      </Link>
                    ))}
                </Box>
                <Stack
                  sx={{
                    width: "100%",
                    height: "100%",
                    mb: 4,
                    justifyContent: "end",
                  }}
                >
                  <Link to="/logout">
                    <ListItem>
                      <LogoutIcon sx={{ color: "white" }} />
                      <Typography ml={2} color="white">
                        Cerrar sesión
                      </Typography>
                    </ListItem>
                  </Link>
                </Stack>
              </Stack>
            </List>
          </Box>
        </div>
      </Drawer>
    </>
  );
}

export default GlobalHeader;
